<script setup lang="ts">
  import { useAnchorNavigationTask } from '@/composables/useAnchorNavigationTask'

  import AnchorNavigationTemplate from '@/components/anchor-navigation/AnchorNavigationTemplate.vue'

  const { content, resourceGuide, subjectResource } = useAnchorNavigationTask()
</script>

<template>
  <AnchorNavigationTemplate
    :top-section-title="subjectResource?.title"
    :top-section-super-title="subjectResource?.category"
    :content="content"
    :resource-guide="resourceGuide"
    is-anchor-task
  />
</template>